<template>
  <div class="about">
    <h2>About</h2>
    <p>This site is in progress.</p>
  </div>
</template>
